{
	"main": {
		"title": "Filtriranje podatkov"
	},
	"labels": {
		"datumOd": "Datum OD :",
		"datumDo": "Datum DO :",
		"klubPJ": "Izberi klub pilota jadralnega:",
		"klubPM": "Izberi klub pilota motornega:",
		"klubJ": "Izberi klub jadralnega letala: ",
		"klubM": "Izberi klub motornega letala:",
		"pilot": "Izberi pilota :",
		"reg": "Izberi reg. letala :",
		"casV": "čas vleke:",
		"stLetov": "Število letov:",
		"casVZ": "čas v zraku:"
	},
	"data": {
		"title": "Podatki"
	},
	"buttons": {
		"csv": "Izvoz v CSV ",
		"natisni": "Natisni ",
		"poslji": "Pošlji ",
		"brisiIzbiro": "Pobriši izbiro",
		"brisiZapis": "Izbriši zapis"
	},
	"table": {
		"reg": "REG",
		"vzlet": "VZLET",
		"pilot": "PILOT",
		"trajanje": "TRAJANJE",
		"naloga": "NALOGA",
		"datum": "DATUM",
		"pristanek": "PRISTANEK",
		"titleJ": "JADRALNI LETI"
	},
	"modal": {
		"izbran": "Izbran zapis",
		"reg": "registracija: ",
		"pilot": "pilot: ",
		"regV": "reg. vleke:",
		"instruktor": "inštruktor: ",
		"namen": "namen: ",
		"naloga": "naloga: ",
		"casV": "čas vzleta: ",
		"casO": "čas odklopa:",
		"casP": "čas pristanka: ",
		"casL": "čas letenja: ",
		"casVL": "čas vleke:",
		"opomba": "opomba: ",
		"datumL": "datum letenja: ",
		"datumV": "datum vnosa: "
	}
}